import commitment from './commitment'

export default [
  ...commitment,
]
